import "core-js/modules/es.error.cause.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { agentsCount } from '@/api/agents';
import { productCount } from '@/api/products';
import { ordersTicketsCount } from '@/api/orders-tickets';
import { getQuery } from '@/utils/index';
import { AdminModule } from '@/store/modules/admin';
import { getDailyOrderValue, totalCurrentRecievable, totalFyPayment, totalFySales } from '@/api/dashboard';
import { BranchAgentService } from '@/services/branch-agent-service';
import { isAdmin, isSuperAdmin } from '@/common';
import { getTotalStockValue } from '@/api/reports';
import Inr from '@/components/Inr/index.vue';
import moment from 'moment';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.supportTicketCount = [];
    this.agentCount = 0;
    this.productscount = 0;
    this.orderscount = 0;
    this.agentId = 0;
    this.agentUserId = 0;
    this.totalFySales = 0;
    this.totalFyPayment = 0;
    this.currentRecievableAmount = 0;
    this.currentMonthSales = 0;
    this.currentMonthPayments = 0;
    this.previousMonthSales = 0;
    this.previousMonthPayments = 0;
    this.dailyOrderValue = 0;
    this.totalStockValue = 0;
    this.isAgent = false;
    this.branchList = [];
    this.branchListLoading = false;
    this.currentMonthDate = '';
    this.currentDateRange = '';
    this.currentFinancialYearDate = '';
    this.previousMonthDate = '';
    this.branchId = null;
    this.assignedBranches = [] || null;
    this.explicitAgentStockValueBranches = null;
    this.applyBranchIdFilter = true;
  }
  created() {
    this.loadModules();
  }
  async loadModules() {
    try {
      if (AdminModule.branchIds.length === 0) {
        throw new Error('You are not assigned to a branch.');
      }
      // Assign branchId using BranchAgentService
      this.assignedBranches = await BranchAgentService.assignBranchId();
      // Check if branchId is null and throw an error
      if (this.assignedBranches === null) {
        throw new Error('You are not assigned to a branch.');
      }
      // Total Stock Value tile: for an Agent, scope strictly to
      // agents_branches (may be an empty array), not the broader branchIds.
      this.explicitAgentStockValueBranches = await BranchAgentService.resolveExplicitAgentBranches();
      // Fetch branches for non-super admin users
      this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
      this.currentMonthDate = {
        start: this.$moment().startOf('month').format('YYYY-MM-DD 00:00') + ' am',
        end: this.$moment().endOf('month').format('YYYY-MM-DD 11:59') + ' pm'
      };
      this.previousMonthDate = {
        start: this.$moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD 00:00') + ' am',
        end: this.$moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD 11:59') + ' pm'
      };
      this.currentDateRange = {
        start: this.$moment().startOf('day').format('YYYY-MM-DD hh:mm') + ' am',
        end: this.$moment().endOf('day').format('YYYY-MM-DD hh:mm') + ' pm'
      };
      const today = this.$moment();
      const year = today.year();
      // If month < April (0-based month index, April = 3)
      const startYear = today.month() < 3 ? year - 1 : year;
      const endYear = today.month() < 3 ? year : year + 1;
      this.currentFinancialYearDate = {
        start: this.$moment(`${startYear}-04-01`).startOf('day').format('YYYY-MM-DD 00:00') + ' am',
        end: this.$moment(`${endYear}-03-31`).endOf('day').format('YYYY-MM-DD 11:59') + ' pm'
      };
      this.agentId = AdminModule.agentId;
      this.agentUserId = AdminModule.id;
      if (AdminModule.roles.includes('Owner')) {
        this.agentUserId = null;
      }
      this.fetchTotalFySales();
      this.fetchTotalFyPayment();
      this.fetchCurrentRecievable();
      this.fetchCurrentMonthSales();
      this.fetchCurrentMonthPayments();
      this.fetchPreviousMonthPayments();
      this.fetchPreviousMonthSales();
      this.fetchDailyOrderValue();
      this.fetchTotalStockValue();
    } catch (err) {
      if (err instanceof Error) {
        this.$notify.error({
          title: 'Error',
          message: err.message
        });
      }
    }
  }
  async handleFilter() {
    var _AdminModule$branchId;
    // handle branch and agent code
    // Fetch agents for a single branch
    if ((!isSuperAdmin() || !isAdmin()) && ((_AdminModule$branchId = AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.branchId = AdminModule.branchIds[0];
    }
    if (this.branchId !== undefined) {
      await BranchAgentService.fetchBranches(this.branchId);
      // Fetch the list after agents and branches are loaded
      this.loadModules();
    } else {
      // await this.handleClearBranch();
      this.loadModules();
    }
  }
  async getSupportTicketCount() {
    this.supportTicketCount = await ordersTicketsCount({});
  }
  async fetchTotalFySales() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.agentUserId) {
      query.agentUserId = this.agentUserId;
      if (this.agentUserId === this.agentId) {
        query.agentUserId = undefined;
      }
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    // ✅ Current Financial Year (India: April 1 – March 31)
    const today = moment();
    const currentYear = today.year();
    const start = today.month() < 3 ? moment(`${currentYear - 1}-04-01`).startOf('day') : moment(`${currentYear}-04-01`).startOf('day');
    const end = today.month() < 3 ? moment(`${currentYear}-03-31`).endOf('day') : moment(`${currentYear + 1}-03-31`).endOf('day');
    query.startDate = start.format('YYYY-MM-DD HH:mm:ss');
    query.endDate = end.format('YYYY-MM-DD HH:mm:ss');
    const data = await totalFySales(query);
    this.totalFySales = isNaN(+data.totalAmount) ? 0 : +data.totalAmount;
  }
  async fetchTotalFyPayment() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true,
      excludeBranches: true
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.agentUserId) {
      query.agentUserId = this.agentUserId;
      if (this.agentUserId === this.agentId) {
        query.agentUserId = undefined;
      }
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    if (this.currentFinancialYearDate) {
      query.startDate = this.currentFinancialYearDate.start;
      query.endDate = this.currentFinancialYearDate.end;
    }
    const data = await totalFyPayment(query);
    this.totalFyPayment = isNaN(+data) ? 0 : +data;
  }
  async fetchCurrentRecievable() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    const data = await totalCurrentRecievable(query);
    this.currentRecievableAmount = +data.totalOutstanding;
  }
  async fetchCurrentMonthSales() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true,
      fromDashboard: true,
      excludeBranches: true
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.agentUserId) {
      query.agentUserId = this.agentUserId;
      if (this.agentUserId === this.agentId) {
        query.agentUserId = undefined;
      }
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    if (this.currentMonthDate) {
      query.startDate = this.currentMonthDate.start;
      query.endDate = this.currentMonthDate.end;
    }
    const data = await totalFySales(query);
    this.currentMonthSales = data.totalAmount;
  }
  async fetchPreviousMonthSales() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true,
      fromDashboard: true,
      excludeBranches: true
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.agentUserId) {
      query.agentUserId = this.agentUserId;
      if (this.agentUserId === this.agentId) {
        query.agentUserId = undefined;
      }
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    if (this.previousMonthDate) {
      query.startDate = this.previousMonthDate.start;
      query.endDate = this.previousMonthDate.end;
    }
    const data = await totalFySales(query);
    this.previousMonthSales = isNaN(+data.totalAmount) ? 0 : +data.totalAmount;
  }
  async fetchCurrentMonthPayments() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true,
      excludeBranches: true
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.agentUserId) {
      query.agentUserId = this.agentUserId;
      if (this.agentUserId === this.agentId) {
        query.agentUserId = undefined;
      }
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    if (this.currentMonthDate) {
      query.startDate = this.currentMonthDate.start;
      query.endDate = this.currentMonthDate.end;
    }
    const data = await totalFyPayment(query);
    this.currentMonthPayments = isNaN(+data) ? 0 : +data;
  }
  async fetchPreviousMonthPayments() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true,
      excludeBranches: true
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.agentUserId) {
      query.agentUserId = this.agentUserId;
      if (this.agentUserId === this.agentId) {
        query.agentUserId = undefined;
      }
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    if (this.previousMonthDate) {
      query.startDate = this.previousMonthDate.start;
      query.endDate = this.previousMonthDate.end;
    }
    const data = await totalFyPayment(query);
    this.previousMonthPayments = isNaN(+data) ? 0 : +data;
  }
  async fetchDailyOrderValue() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    const currentDate = this.$moment().format('YYYY-MM-DD');
    const startOfDay = this.$moment(currentDate).startOf('day').format('YYYY-MM-DD HH:mm:ss');
    const endOfDay = this.$moment(currentDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');
    query.startDate = startOfDay;
    query.endDate = endOfDay;
    const data = await getDailyOrderValue(query);
    this.dailyOrderValue = isNaN(+data.total) ? 0 : +data.total;
  }
  async fetchTotalStockValue() {
    try {
      // Agent: strictly scope to agents_branches, ignoring the broader
      // branchId/assignedBranches used everywhere else. An empty
      // agents_branches mapping means zero, not "no filter".
      if (this.explicitAgentStockValueBranches !== null) {
        if (this.explicitAgentStockValueBranches.length === 0) {
          this.totalStockValue = 0;
          return;
        }
        const data = await getTotalStockValue({
          enabled: true,
          page: 1,
          limit: 1000,
          assignedBranches: this.explicitAgentStockValueBranches.join(',')
        });
        this.totalStockValue = data.totalStockValue;
        return;
      }
      const query = {
        enabled: true,
        page: 1,
        limit: 1000
      };
      if (this.branchId) {
        query.branchId = this.branchId;
      } else if (this.assignedBranches) {
        query.assignedBranches = Array.isArray(this.assignedBranches) ? this.assignedBranches.join(',') : this.assignedBranches;
      }
      const data = await getTotalStockValue(query);
      this.totalStockValue = data.totalStockValue;
    } catch (error) {
      this.totalStockValue = 0;
    }
  }
  async getProductCount() {
    try {
      this.productscount = await productCount(getQuery({
        enabled: true,
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async getAgentCount() {
    this.agentCount = await agentsCount(getQuery({
      enabled: true,
      filter: {
        enabled: 'eq'
      }
    }));
  }
};
default_1 = __decorate([Component({
  name: 'PanelGroup',
  components: {
    Inr
  }
})], default_1);
export default default_1;